import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Row, Col } from '@bingads-webui-react/primitive';
import { Input } from '@bingads-webui-react/primitive-with-validation-and-signal';
import { ValidationGroup } from '@bingads-webui-react/primitive-validation';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const userSchema = {
  name: 'User schema',
  type: 'object',
  properties: {
    firstName: {
      type: 'string',
      required: true,
      maxLength: 40,
      pattern: '^(?:(?![\x00-\x1f]|[\x21-\x26]|[\x28-\x2c]|\x2f|[\x3a-\x40]|[\x5b-\x5e]|\x60|[\x7b-\x7f]|\x81|\xa0|\xad).)*$',
    },
    lastName: {
      type: 'string',
      required: true,
      maxLength: 40,
      pattern: '^(?:(?![\x00-\x1f]|[\x21-\x26]|[\x28-\x2c]|\x2f|[\x3a-\x40]|[\x5b-\x5e]|\x60|[\x7b-\x7f]|\x81|\xa0|\xad).)*$',
    },
    email: {
      type: 'string',
      required: true,
      pattern: '^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$',
    },
  },
};

export const SignupUserInfoForm = (props) => {
  const {
    onValidate,
    defaultValue,
  } = props;
  const i18n = useContext(I18nContext);


  return (
    <div className="signup-user-info-form">
      <ValidationGroup validationProps={{
        schema: userSchema,
        onValidate,
        data: defaultValue,
      }}
      >
        <FormGroup>
          <Row>
            <Col sm={12}> <Label id="firstName">{i18n.getString(_TL_('First name'))}</Label></Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Input
                validationProps={{ field: 'firstName' }}
                aria-labelledby="firstName"
                className="first-name"
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col sm={12}><Label id="lastName">{i18n.getString(_TL_('Last name'))}</Label></Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Input
                validationProps={{ field: 'lastName' }}
                aria-labelledby="lastName"
                className="last-name"
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col sm={12}>
              <Label>
                <span id="email">{i18n.getString(_TL_('Email'))}</span>
                <HelpPopup
                  aria-label={i18n.getString(_TL_('Click to learn more about email'))}
                  topic="Page_Signup_EmailAdress"
                />
              </Label>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Input
                validationProps={{ field: 'email' }}
                aria-labelledby="email"
                className="email"
              />
            </Col>
          </Row>
        </FormGroup>
      </ValidationGroup>
    </div>
  );
};

SignupUserInfoForm.propTypes = {
  onValidate: PropTypes.func.isRequired,
  defaultValue: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
};

SignupUserInfoForm.defaultProps = {
  defaultValue: undefined,
};

